<div class="regulatory-dialog-container">
  <div class="dialog-header flex-space-between padding">
    <div class="header-left flex-centered-container-vr gap-8-px">
      <mat-icon class="warn-icon warning-text material-icons-outlined">warning</mat-icon>
      <div class="title font-12">Regulatory Caution on {{ items?.length || 0 }} Symbol{{((items?.length || 0) > 1 ? 's' : '')}}</div>
    </div>
    <mat-icon class="cursor-pointer close-icon" (click)="close()">close</mat-icon>
  </div>
  <mat-divider></mat-divider>

  <div class="dialog-content font-12">
    <div class="symbol-section" *ngFor="let item of items; trackBy: trackBySymbol">
      <div class="symbol-chip regulatory-symbol-chip">{{ item.symbol }}</div>

      <div class="symbol-title">
        <span class="font-bold">{{ item.name || item.symbol }}</span>
        <span class="symbol-title-text"> has the following cautionary messages -</span>
      </div>

      <ul class="message-list">
        <li *ngFor="let msg of item.messages; trackBy: trackByMessage">{{ msg }}</li>
      </ul>
    </div>
  </div>


  <mat-divider></mat-divider>
  <div class="table-gray-header flex-space-between padding pad-8-vr font-12 ">
    <div class="width-70">{{ noteText }}</div>

    <button mat-flat-button color="accent" class="new-submit-button flex-centered-container width-20" (click)="accept()">Proceed</button>
    
  </div>
</div>
